const EditText = (blurb: string): string => {
  // Declare the chunk of text to be [140] characters
  blurb = blurb.match(/.{1,140}(\s|$)/g)[0];
  return blurb;
};

export default EditText;
